import type { ComboboxOption } from '../components/ui/combobox';

export const getAggregationOptionsForFieldType = (fieldType: string, vizOnly: boolean = false): ComboboxOption[] => {
  const options: ComboboxOption[] = [{
    value: 'COUNT_DISTINCT',
    label: 'Count Distinct',
  }];

  if (!vizOnly) {
    options.push({
      value: 'PICK_ONE',
      label: 'Random',
    });
  }

  switch (fieldType) {
    case 'DATE':
    case 'DATETIME':
    case 'DATETIME_TZ':
      options.push({
        value: 'MIN',
        label: 'Min'
      });
      options.push({
        value: 'MAX',
        label: 'Max',
      });
      break;
    case 'INT':
    case 'DECIMAL':
      options.push({
        value: 'MIN',
        label: 'Min',
      });
      options.push({
        value: 'MAX',
        label: 'Max',
      });
      options.push({
        value: 'AVG',
        label: 'Avg'
      });
      options.push({
        value: 'SUM',
        label: 'Sum'
      });
      options.push({
        value: 'MEDIAN',
        label: 'Median'
      });
      break;
    case 'STRING':
      if (!vizOnly) {
        options.push({
          value: 'CONCAT',
          label: 'Comma-separated list of unique values',
        });
      }
      break;
  }
  return options;
};
